<template>
<div class="shopModule" :class="{'margin':margin}">
    <div class="module">
        <div class="modules">
            <div class="item" v-for="(item,index) in typeList" :class="'item'+item.listStyle" @click="goPage(item.url,item,i)">
                <img :src="item.logo">
                <p v-if="isShowName">{{item.moduleName}}</p>
            </div>

        </div>
    </div>

</div>
</template>

<script>
var config = {};
import api from '@/utils/api';
import {
    jAlert3
} from '@/base/jAlert/jAlert';
import {
    getStorage
} from '@/utils/wxuser';
import gcTrack from "@/utils/gcTrack";
export default {
    data() {
        return {
            typeList: [],
            margin: false
        };
    },
    props: {
        isShowName: {
            type: Boolean,
            default: true
        },
        isMargin: {
            type: Boolean,
            default: false
        },
        supplierCode: {
            type: String,
            default: ''
        }
    },
    methods: {
        goPage(url, item, i) {
            if (url != '') {
                var data = {
                    banner_belong_area: '首页icon区',
                    banner_type: "",
                    banner_name: item.moduleName,
                    banner_id: item.id,
                    banner_rank: i + 1
                }
                gcTrack.track("SC_HomeOoperationClick", data)
                window.location.href = this.wrapperUrl(url);
            }
        },
        getListType() {
            var opt = {
                hotelGroupCode: config.hotelGroupCode,
                belongHotelCode: config.hotelCode
            }
            if (this.supplierCode != '') {
                opt.supplierCode = this.supplierCode
            }
            api
                .getListType(opt)
                .then(res => {
                    if (res.result === 1) {
                        this.typeList = [];
                        res.retVal.forEach(item => {
                            var clientType = config.clientType
                            if (config.clientType == 'wechat_mini') {
                                clientType = 'wechat_mini_pro'
                            }
                            if (item.clientType == clientType && item.isBottom != 'T') {
                                if (item.pictureType == '0') {
                                    item.listStyle = '0';
                                }
                                // if(item.listStyle==1){
                                // 	item.listStyle=2
                                // }else if(item.listStyle==2){
                                // 	item.listStyle=1
                                // }
                                // if (!this.typeList[item.listStyle]) {
                                //   this.typeList[item.listStyle] = [];
                                // }
                                // this.typeList[item.listStyle].push(item);
                                this.typeList.push(item)
                            }
                        });
                        console.log(this.typeList);
                    } else {
                        jAlert3(res.msg);
                    }
                });
        }
    },
    mounted() {
        this.margin = this.isMargin
        this.getListType();
    },
    created() {
        config = getStorage('config');
    }
};
</script>

<style lang="less" scoped>
@import url('~@/styles/base.less');
@import url('~@/styles/mixin.less');

.shopModule {
    &.margin {
        margin-top: -1rem;
    }

    .module {
        .modules {
            display: flex;
            flex-wrap: wrap;

            .item0 {
                width: 25%;
                margin-top: 0.4rem;
                display: flex;
                flex-direction: column;
                align-items: center;

                img {
                    border-radius: 50%;
                    height: 0.96rem;
                    width: 0.96rem;
                }

                p {
                    margin-top: 0.186667rem;
                    font-size: 14px;
                    color: #333333;
                    line-height: 0.533333rem;
                }
            }

            .item1 {
                padding: 0 0.266667rem;
                margin-top: 0.266667rem;
                width: 100%;
                height: 1.92rem;
                position: relative;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 5px;
                }

                p {
                    position: absolute;
                    font-weight: bold;
                    top: 0.186667rem;
                    line-height: 0.533333rem;
                    left: 0;
                    color: #ffffff;
                    padding: 0 0.266667rem;
                    width: 100%;
                    font-size: 14px;
                }

                span {
                    top: 0.72rem;
                    padding: 0 0.266667rem;
                    width: 100%;
                    position: absolute;
                    font-size: 12px;
                    color: #cccccc;
                }
            }

            .item2,
            .item4 {
                width: 50%;
                margin-top: 0.266667rem;
                display: flex;
                padding: 0 0.133333rem;
                box-sizing: border-box;
                flex-direction: column;
                align-items: center;
                position: relative;

                img {
                    width: 100%;
                    height: 1.92rem;
                    border-radius: 5px;
                }

                p {
                    position: absolute;
                    font-weight: bold;
                    top: 0.186667rem;
                    line-height: 0.533333rem;
                    left: 0;
                    color: #ffffff;
                    padding: 0 0.266667rem;
                    width: 100%;
                    font-size: 14px;
                }

                span {
                    top: 0.72rem;
                    padding: 0 0.266667rem;
                    width: 100%;
                    position: absolute;
                    font-size: 12px;
                    color: #cccccc;
                }

            }

            &.item3 {
                padding: 0 0.133333rem;

                .item {
                    width: 50%;
                    margin-top: 0.266667rem;
                    display: flex;
                    padding: 0 0.133333rem;
                    box-sizing: border-box;
                    flex-direction: column;
                    align-items: center;
                    position: relative;

                    &:nth-child(3n+0) {
                        width: 100%;
                    }

                    img {
                        width: 100%;
                        height: 1.92rem;
                        border-radius: 5px;
                    }

                    p {
                        position: absolute;
                        font-weight: bold;
                        top: 0.186667rem;
                        line-height: 0.533333rem;
                        left: 0;
                        color: #ffffff;
                        padding: 0 0.266667rem;
                        width: 100%;
                        font-size: 14px;
                    }

                    span {
                        top: 0.72rem;
                        padding: 0 0.266667rem;
                        width: 100%;
                        position: absolute;
                        font-size: 12px;
                        color: #cccccc;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/shopModule.vue